const incomingCall = {
  content: 'Toast-Incoming-Call-Content',
  acceptButton: 'Toast-Incoming-Call-AcceptButton',
  rejectButton: 'Toast-Incoming-Call-RejectButton',
  escalationSummary: 'Toast-Incoming-Call-EscalationSummary',
};

export const toastlocators = {
  incomingCall,
};
